import { P1, P2 } from "components/atoms/Paragraph";
import styled from "styled-components";
import { color } from "@styles";
import Image from "next/image";
import { tablet } from "components/templates/Breakpoints";

export const ModalContainer = styled.div`
  width: 37rem;
  max-height: 37.5rem;
  transform-origin: top right;
  border: 1px solid ${color.B230};
  border-radius: 0.5rem;
  display: flex;
  background: ${color.white};
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.5rem;
  z-index: 2;

  ${tablet} {
    margin: 1rem;
  }
`;

export const InnerModalContainer = styled.div`
  padding: 1.75rem 1.75rem 0 1.75rem;
  margin: 0 auto;
  width: 100%;
`;

export const Container = styled.div<{ pb?: string }>`
  display: flex;
  max-height: 4rem;
  width: fit-content;
  display: flex;
  align-items: center;
  padding-bottom: ${(p) => p.pb || "1.5rem"};
`;

export const ServiceInfo = styled.div`
  min-width: fit-content;
`;

export const TooltipWrap = styled.div`
  width: 1.5rem;
  border-radius: 0.5rem;
  padding-left: 0.5rem;
`;

export const ServiceName = styled(P2)`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 2.5rem;
  min-width: fit-content;
  padding: 0rem 0rem 0rem 1rem;
`;

export const ServiceSubheader = styled(P2)`
  font-size: 0.75rem;
  line-height: 0.5rem;
  padding: 0rem 0rem 0rem 1rem;
`;

export const PlaceHolderReward = styled.div`
  width: 7.5rem;
  height: 6.5rem;
  background: ${color.white};
`;

export const RewardImage = styled(Image)`
  width: 7.5rem;
  height: 6.5rem;
  padding: 0;
  border-radius: 0.5rem;
`;

export const RewardsSection = styled.div`
  padding-bottom: 1.5rem;
`;

export const RewardsScroll = styled.div<{ $hasScrolled: boolean; $showGradient: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 1.09rem;
  overflow-y: scroll;
  max-height: 14.5rem;

  &:before {
    content: "";
    position: absolute;
    bottom: 1rem;
    width: 34rem;
    height: 4.5rem;
    opacity: ${(p) => (p.$showGradient ? "1" : "0")};
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
    ${(p) => (p.$hasScrolled && p.$showGradient ? `transition: opacity 0.2s ease` : "")};
  }
`;

export const RewardsTitle = styled(P1)`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.0625rem;
  padding-bottom: 1.5rem;
`;

export const Flex = styled.div`
  display: flex;
  padding-bottom: 1.5rem;
  justify-content: space-between;
`;

export const CloseIcon = styled(Image)`
  margin-bottom: 1rem;
  cursor: pointer;
`;
